import { render, staticRenderFns } from "./docPermission.vue?vue&type=template&id=47c1fda5&scoped=true"
import script from "./docPermission.vue?vue&type=script&lang=js"
export * from "./docPermission.vue?vue&type=script&lang=js"
import style0 from "./docPermission.vue?vue&type=style&index=0&id=47c1fda5&prod&lang=scss"
import style1 from "./docPermission.vue?vue&type=style&index=1&id=47c1fda5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47c1fda5",
  null
  
)

export default component.exports